/*
 * YumeFeel Sprint 1 (2026-09-28): the ad-landing modules. One deferred ES module, loaded by each block or section
 * that needs it (the browser runs it once). Nothing here blocks rendering or moves screen 1.
 *   tiles      package tiles (M1-A): registers the Sleep Set as a YfBuy target (assets/variants.js)
 *   offer      cover price per size, gift end-date re-check (M1-B/C)
 *   sheets     answer sheets on <dialog> (M4) and the gift terms
 *   plans      the to-scale bed plan (fit view, fit sheet, showroom, finder)
 *   showroom   labelled chips over one media stage (M3)
 *   views      ?view= modules: landed/CTA events, loops (M2)
 *   gift       Sleep Set nudge and "Send a hint" (M5)
 *   finder     Find your bed, saved bed, share, optional capture (M6)
 * Every module has a no-JS fallback in its Liquid. Events go through window.yfTrack (Shopify Customer Events).
 */
const doc = document;
const $ = (s, r = doc) => r.querySelector(s);
const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
const track = (name, data) => { try { if (window.yfTrack) window.yfTrack(name, data || {}); } catch (e) {} };
const json = (el) => { try { return el ? JSON.parse(el.textContent || el) : null; } catch (e) { return null; } };
const mq = (q) => { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
const REDUCE = mq("(prefers-reduced-motion: reduce)");
const SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
const CFG = json($("#yf-landing-config")) || {};
const BED_KEY = "yf.bed.v1";
const MATS = { Full: [54, 75], Queen: [60, 80], King: [76, 80], "Cal King": [72, 84] };
const MAT_ORDER = ["Full", "Queen", "King", "Cal King"];

function ctl(el) {
  if (!window.YfBuy || !el) return null;
  try { return window.YfBuy.get(el); } catch (e) { return null; }
}
function chosen(c) { return !!(c && c.state !== "choose" && c.variant && c.variant.id); }
function sizeOf(c) {
  if (!chosen(c)) return "";
  const v = c.variant;
  return String(v.option1 || (Array.isArray(v.options) && v.options[0]) || v.title || "");
}
function money(c, cents) { return c ? c.money(cents) : window.YfBuy ? window.YfBuy.formatMoney(cents) : "$" + (cents / 100).toFixed(2); }
function onBuy(c, fn) {
  doc.addEventListener("yf:buy", (e) => {
    const d = e.detail || {};
    if (!c || d.id !== c.id || d.clone) return;
    fn(d);
  });
}
function announce(c, msg) { if (c && typeof c.announce === "function") c.announce(msg); }
// One rounding rule for every fit number (plan, outcome line, finder, sheet): cm geometry to 0.1 in, with an
// epsilon so float noise never flips a .x5 (matches yf-bed-plan's Liquid round and the Size & Feel page).
function r1n(n) { return Math.round((n + (n < 0 ? -1e-9 : 1e-9)) * 10) / 10; }
function f1(n) { return r1n(n).toFixed(1).replace(/\.0$/, ""); }
function r1(n) { return r1n(n).toString(); }
// Sprint 1B: every duvet size is cut for its own mattress, so the duvet is the mattress size (Full → Queen).
function duvetFor(mattress) { return mattress === "Full" ? "Queen" : mattress; }
function findDuvet(names, size) {
  return names.find((n) => n === size) || names.find((n) => n === "King") || names[0];
}
function stateBed() { return window.__yfBed || null; }
function setBed(bed) {
  window.__yfBed = Object.assign({}, window.__yfBed || {}, bed);
  doc.dispatchEvent(new CustomEvent("yf:bed", { detail: window.__yfBed }));
}
function store(kind) { try { const s = window[kind]; const k = "__yf_t"; s.setItem(k, "1"); s.removeItem(k); return s; } catch (e) { return null; } }
const LS = store("localStorage");
const SS = store("sessionStorage");
// The landing URL as the visitor arrived (snippets/yf-track saves it before any script rewrites ?variant=).
const Q = (() => { try { return new URLSearchParams(window.__yfLandingSearch != null ? window.__yfLandingSearch : location.search); } catch (e) { return new URLSearchParams(""); } })();
if (Q.get("bed") && MATS[Q.get("bed")]) setBed({ mattress: Q.get("bed"), source: "link" });

/* ---------------------------------------------------------------- tiles (M1-A) */
function initTiles(fs) {
  const c = ctl(fs);
  const T = json($("script[data-yf-target]", fs));
  if (!c || !T || typeof c.setTarget !== "function" || typeof window.FormDataEvent === "undefined") {
    fs.classList.add("is-fallback");
    const b = $('input[value="sleep"]', fs);
    if (b) b.disabled = true;
    return;
  }
  c.registerTarget(T);
  c.__tiles = T;
  const inA = $('input[value="base"]', fs), inB = $('input[value="sleep"]', fs);
  const tileB = inB.closest(".yf-tile");
  const KEY = "yf:set:" + (fs.dataset.handle || "");
  let offB = false;
  function vData() { return chosen(c) ? (T.variants || {})[String(c.variant.id)] : null; }
  function paint() {
    const isChosen = chosen(c), size = sizeOf(c), v = vData();
    const m = isChosen ? T.map[String(c.variant.id)] : null;
    const pA = $("[data-yf-tile-price]", inA.parentNode), wA = $("[data-yf-tile-was]", inA.parentNode);
    const pB = $("[data-yf-tile-price]", tileB), wB = $("[data-yf-tile-was]", tileB);
    pA.textContent = isChosen ? money(c, c.variant.price) : T.base.fromText;
    const cmpA = v && v.compare > v.price ? v.compare : 0;
    wA.hidden = !cmpA; wA.textContent = cmpA ? money(c, cmpA) : "";
    offB = isChosen && !m;
    tileB.classList.toggle("is-off", offB);
    const status = $("[data-yf-tile-status]", tileB), save = $("[data-yf-tile-save]", tileB);
    status.hidden = !offB;
    status.textContent = offB ? `Not available in ${size} right now` : "";
    pB.textContent = m ? money(c, m.price) : T.fromText;
    wB.hidden = !(m && m.compare > m.price);
    wB.textContent = m && m.compare > m.price ? money(c, m.compare) : "";
    // Sprint 1B: one saving story (the compare-at). Tile B states the true difference: "+$200 for 2 pillows and 2 cases".
    const saveText = offB ? "" : m ? (m.extra > 0 ? `+${money(c, m.extra)} for 2 pillows and 2 cases` : "") : T.saveNone || "";
    save.textContent = saveText;
    save.hidden = !saveText;
    const link = $("[data-yf-tile-link]", tileB);
    if (link) link.href = T.url + (m ? "?variant=" + m.id : "");
    const locked = c.state === "adding" || c.state === "pending";
    fs.toggleAttribute("data-yf-locked", c.state === "adding");
    inA.disabled = c.state === "adding";
    inB.disabled = c.state === "adding" || offB;
    const isSleep = !!(c.target && c.target.key === "sleep");
    inB.checked = isSleep;
    inA.checked = !isSleep;
    if (isSleep && offB && !locked) {
      c.setTarget(null);
      announce(c, `${T.name} is not available in ${size} right now. ${T.base.name} chosen.`);
    }
    paintFull(size);
  }
  function paintFull(size) {
    const box = $("[data-yf-tiles-full]", fs);
    if (!box || !T.full) return;
    const a = $("[data-yf-tiles-full-link]", box), pair = $("[data-yf-tiles-full-pair]", box);
    const bed = stateBed() || {};
    const vs = (T.full.variants || []).filter((x) => x.a);
    // Exact size: the Full Cloud Bed Set's fitted sheet is per mattress, so a Full mattress has no match.
    const hide = bed.mattress === "Full";
    let list = vs;
    if (size) list = vs.filter((x) => x.o === size);
    else if (bed.mattress) list = vs.filter((x) => x.o === bed.mattress);
    // Royal build P2: the Full link also matches the second option (Warmth) when the JSON carries it ("o2").
    const o2 = chosen(c) ? String(c.variant.option2 || String(c.variant.title || "").split(" / ")[1] || "") : "";
    if (size && o2 && list.some((x) => x.o2 != null)) {
      list = list.filter((x) => x.o2 === o2);
    }
    box.hidden = hide || !list.length;
    if (hide || !list.length || !pair) return;
    const one = list.length === 1 ? list[0] : null;
    if (one) {
      // Royal fix r1 (TC-21): the hidden label copies the page's own ("Was " on Cloud, "Crossed-out price " on Royal).
      const wl = ((document.querySelector(".yf-pp__was .yf-visually-hidden") || {}).textContent || "Was ").replace(/[<>&"]/g, "");
      if (!$("[data-now]", pair)) pair.innerHTML = '<span class="yf-pp yf-pp--md"><span class="yf-pp__was" data-was hidden><span class="yf-visually-hidden">' + wl + '</span><s class="yf-was" data-was-amt></s> </span><span class="yf-now" data-now></span></span>';
      window.YfBuy.paintPair(pair, one.p, one.c || 0, c.cfg.moneyFormat);
    } else {
      pair.textContent = "from " + money(c, Math.min.apply(null, list.map((x) => x.p)));
    }
    a.href = T.full.url + (one ? "?variant=" + one.id : "");
  }
  function choose(key, source) {
    c.setTarget(key);
    try { if (SS) SS.setItem(KEY, key || "base"); } catch (e) {}
    const rt = c.resolvedTarget();
    const name = key ? T.name : T.base.name;
    const size = sizeOf(c);
    const price = key ? (rt && rt.price != null ? money(c, rt.price) : T.fromText) : size ? money(c, c.variant.price) : T.base.fromText;
    announce(c, size ? `${name} chosen. ${price} in ${size}.` : `${name} chosen. ${/^From/.test(price) ? price : "From " + price}.`);
    if (source) track("yf_package_select", { package: key ? "sleep" : "duvet", size, source });
    paint();
  }
  fs.addEventListener("change", (e) => {
    if (e.target === inB && inB.checked) choose("sleep", "tile");
    else if (e.target === inA && inA.checked) choose(null, "tile");
  });
  onBuy(c, paint);
  doc.addEventListener("yf:bed", () => paintFull(sizeOf(c)));
  let want = Q.get("set") === "sleep" ? "sleep" : null;
  if (!Q.has("set") && SS) { try { want = SS.getItem(KEY) === "sleep" ? "sleep" : null; } catch (e) {} }
  if (want && !(chosen(c) && !T.map[String(c.variant.id)])) c.setTarget("sleep");
  paint();
  window.YfLanding = Object.assign(window.YfLanding || {}, { choose: (key, source) => choose(key, source) });
  // A "want pillows too?" link to the upgrade set chooses it in the tiles here instead of leaving the page.
  doc.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest("a[data-yf-set-add]");
    if (!a || inB.disabled || e.metaKey || e.ctrlKey || e.shiftKey) return;
    let same = false;
    try { same = new URL(a.href, location.href).pathname.replace(/\/$/, "") === new URL(T.url, location.href).pathname.replace(/\/$/, ""); } catch (err) {}
    if (!same) return;
    e.preventDefault();
    choose("sleep", "contents_link");
    fs.scrollIntoView({ behavior: REDUCE ? "auto" : "smooth", block: "center" });
  });
}

/* ---------------------------------------------------------------- fit line (Sprint 1B) */
// "On a King mattress it hangs 18.1 in past each side and 18.4 in past the foot." Each size input carries
// data-yf-fit="side|foot|mat_w|mat_l" from Liquid (snippets/yf-fit-line); a pick rewrites the text only.
function initFitLine(p) {
  const c = ctl(p);
  const out = $("[data-yf-fit-text]", p);
  const tpl = p.getAttribute("data-tpl") || "";
  if (!c || !out || !tpl) return;
  const esc = (s) => String(s).replace(/[&<>"]/g, "");
  const paint = () => {
    const input = $('variant-options input[type="radio"][data-position="1"][data-yf-fit]:checked', c.root);
    if (!input) return;
    const [side, foot, mw, ml] = (input.getAttribute("data-yf-fit") || "").split("|");
    if (!side) return;
    const html = tpl.replace("[size]", esc(input.value)).replace("[mw]", esc(mw)).replace("[ml]", esc(ml)).replace("[side]", esc(side)).replace("[foot]", esc(foot));
    if (out.innerHTML !== html) out.innerHTML = html;
  };
  onBuy(c, paint);
  paint();
}

/* ---------------------------------------------------------------- offer (M1-B/C) and gift end re-check */
// Sprint 1C fix r2: the held order code (LOVE, $150 off from $649). html[data-yf-love] comes from snippets/yf-love-state
// (the cart applies it, or the /discount link saved it); D.love = {code, amt, min, sub, in} from snippets/yf-offer-stack.
// The code counts for this price when the rest of the cart is under the minimum and this price takes it over. Both
// texts are always painted; CSS shows the code ones only under html[data-yf-love] [data-yf-love-ok], so a size pick or
// the code arriving never inserts a row.
// Sprint 1C fix r3: "the rest of the cart" = the items subtotal minus one unit of the variant this price adds (vid),
// when that variant is already in the cart; the numbers come from the latest /cart.js read (window.YfLove.cart, kept by
// snippets/yf-love-state after every cart update) or else from Liquid. The King in the cart still reads $549, a
// second size of the same set reads its full price, and a different set in the cart spends the code as before.
function loveCart(D) {
  const live = window.YfLove && window.YfLove.cart;
  if (live && typeof live.sub === "number") return live;
  const L = (D && D.love) || {};
  return { sub: typeof L.sub === "number" ? L.sub : L.other || 0, in: L.in || {} };
}
function loveFor(D, p, vid) {
  const L = D && D.love;
  if (!L || !(L.amt > 0)) return 0;
  const cart = loveCart(D);
  const mine = vid != null && cart.in ? Number(cart.in[String(vid)]) || 0 : 0;
  const other = Math.max(0, (cart.sub || 0) - mine);
  return other < L.min && other + p >= L.min ? Math.min(L.amt, p) : 0;
}
// Sprint 1C fix r3: repaint whatever shows the code when the cart numbers change (an Add, a remove, the drawer).
const lovePaints = [];
function onLoveCart(fn) { lovePaints.push(fn); }
doc.addEventListener("yf:love-cart", () => lovePaints.forEach((fn) => { try { fn(); } catch (e) {} }));
function loveHeld() { return doc.documentElement.hasAttribute("data-yf-love"); }
function loveCode(D) { return String((D && D.love && D.love.code) || "").replace(/[^A-Za-z0-9_-]/g, ""); }
function initOffer(box) {
  const c = ctl(box), D = json($("script[data-yf-stack]", box));
  if (!c || !D || !D.v) return;
  const set = (k, t) => $$(`[data-yf-s="${k}"]`, box).forEach((el) => { if (el.textContent !== t) el.textContent = t; });
  const flag = (k) => { try { return !!sessionStorage.getItem(k); } catch (e) { return false; } };
  const row = (k) => $(`[data-row="${k}"]`, box);
  const was = (r, on) => { const s = r && $(".yf-box__was", r); if (s) s.hidden = !on; };
  let spoken = "";
  function paint(user) {
    const vid = chosen(c) ? String(c.variant.id) : String(D.sel);
    const base = D.v[vid] || D.v[String(D.sel)];
    if (!base) return;
    const rt = c.resolvedTarget && c.resolvedTarget();
    const tgt = rt && rt.key && D.t && D.t[rt.key] && D.t[rt.key][vid];
    const giftRow = row("gift"), bfcmRow = row("bfcm"), coverRow = row("cover");
    // Session flags come from the cart's discount guard (snippets/yf-gifts): a gift that would not be free is never shown.
    const g = D.gift.on && giftRow && !flag("yf:gift:nodisc") ? base.g : 0;
    const b = D.bfcm.on && bfcmRow && !flag("yf:bfcm:nodisc") ? base.b : 0;
    if (giftRow) giftRow.hidden = !!(D.gift.on && flag("yf:gift:nodisc"));
    if (bfcmRow) bfcmRow.hidden = !!(D.bfcm.on && flag("yf:bfcm:nodisc"));
    const w = tgt ? tgt.w : base.w, p = tgt ? tgt.p : base.p;
    const cv = tgt || !coverRow ? 0 : base.c;
    const total = w + cv + g + b, save = total - p;
    const coverSheet = doc.getElementById(box.dataset.coverSheet);
    if (coverSheet) {
      let coverUrl = "";
      $$("[data-yf-included-size]", coverSheet).forEach((el) => {
        el.hidden = el.dataset.yfIncludedSize !== base.s;
        if (!el.hidden) coverUrl = el.dataset.productUrl;
      });
      if (coverUrl) $$("[data-yf-cover-link]", box).concat($$("[data-yf-included-page]", coverSheet)).forEach((el) => el.href = coverUrl);
    }
    const setPreview = $("[data-yf-set-preview]", box);
    if (setPreview) {
      setPreview.setAttribute("aria-label", tgt ? setPreview.dataset.targetLabel : setPreview.dataset.baseLabel);
      setPreview.dataset.yfSheetOpen = tgt ? setPreview.dataset.targetSheet : setPreview.dataset.baseSheet;
      setPreview.href = `${tgt ? setPreview.dataset.targetUrl : setPreview.dataset.baseUrl}?variant=${tgt ? tgt.id : vid}`;
      const setSheet = doc.getElementById(setPreview.dataset.yfSheetOpen);
      if (setSheet) $$("[data-yf-included-page]", setSheet).forEach((el) => el.href = setPreview.href);
    }
    set("size", base.s);
    set("set-name", tgt ? tgt.n : box.dataset.setName || "");
    set("set-meta", tgt ? tgt.m : base.m);
    set("set-was", money(c, w));
    was(row("set"), w > p);
    set("set-now", money(c, p));
    if (coverRow) {
      const coverValue = Number(base.cd == null ? base.c : base.cd) || 0;
      const offerText = D.text || {};
      if (offerText.limited) set("cover-meta", `${base.s} · ${offerText.limited}`);
      set("cover-was", coverValue > 0 ? money(c, coverValue) : "");
      was(coverRow, coverValue > 0);
      const now = $('[data-yf-s="cover-now"]', coverRow);
      if (now) {
        now.classList.add("is-free");
        now.classList.remove("is-incl");
        if (offerText.free && now.textContent !== offerText.free) now.textContent = offerText.free;
      }
    }
    if (bfcmRow) {
      set("bfcm-meta", `${/king/i.test(base.s) ? "King" : "Queen"} pair`);
      set("bfcm-was", money(c, base.b));
    }
    set("total-was", money(c, total));
    was(box.querySelector(".yf-box__total"), total > p);
    set("total-now", money(c, p));
    set("save", money(c, save));
    const lv = loveFor(D, p, tgt && tgt.id ? tgt.id : vid);
    set("total-now-love", money(c, p - lv));
    set("save-love", money(c, save + lv));
    box.toggleAttribute("data-yf-love-ok", lv > 0);
    const band = $(".yf-box__save", box);
    if (band) band.hidden = !(save > 0);
    box.toggleAttribute("data-yf-target", !!tgt);
    const msg = lv > 0 && loveHeld()
      ? `${base.s}: ${money(c, p - lv)} with the ${loveCode(D)} code, you save ${money(c, save + lv)}.`
      : `${base.s}: ${money(c, p)}, you save ${money(c, save)}.`;
    if (user && chosen(c) && msg !== spoken) { spoken = msg; announce(c, msg); }
    spoken = spoken || msg;
  }
  onBuy(c, (d) => paint(d && d.state !== "pending"));
  doc.addEventListener("yf:love", () => paint(false));
  onLoveCart(() => paint(false));
  paint(false);
}
// Sprint 1B: the stack numbers for the current size and package, from a data-yf-stack JSON (snippets/yf-offer-stack).
// Closing boxes prefer the main buy box's JSON (it carries the Sleep target) and fall back to their own.
function sflag(k) { try { return !!sessionStorage.getItem(k); } catch (e) { return false; } }
function stackData(c, scope) {
  const main = c && c.root ? $("[data-yf-offer] script[data-yf-stack]", c.root) : null;
  return json(main || $("script[data-yf-stack]", scope));
}
function stackCalc(D, c) {
  if (!D || !D.v) return null;
  const vid = chosen(c) ? String(c.variant.id) : String(D.sel);
  const rt = c && c.resolvedTarget && c.resolvedTarget();
  return stackFor(D, vid, rt && rt.key);
}
function stackFor(D, vid, key) {
  if (!D || !D.v) return null;
  const base = D.v[String(vid)] || D.v[String(D.sel)];
  if (!base) return null;
  const tgt = key && D.t && D.t[key] && D.t[key][String(vid)];
  const g = D.gift && D.gift.on && !sflag("yf:gift:nodisc") ? base.g : 0;
  const b = D.bfcm && D.bfcm.on && !sflag("yf:bfcm:nodisc") ? base.b : 0;
  const cv = tgt || !(D.cover && D.cover.on) ? 0 : base.c;
  const w = tgt ? tgt.w : base.w, p = tgt ? tgt.p : base.p;
  const total = w + cv + g + b;
  return { base, tgt, w, p, c: cv, cd: Number(base.cd == null ? base.c : base.cd) || 0, g, b, total, save: total - p, love: loveFor(D, p, tgt && tgt.id ? tgt.id : vid), code: loveCode(D) };
}
function sumLine(n) {
  const parts = [];
  if (n.cd > 0) parts.push("cover");
  if (n.g > 0) parts.push(n.b > 0 ? "spray" : "lavender spray");
  if (n.b > 0) parts.push("pillowcases");
  if (!parts.length) return "";
  if (parts.length === 1) return "Free " + parts[0];
  return "Free " + parts.slice(0, -1).join(", ") + " + " + parts[parts.length - 1];
}
function paintSummary(scope, c) {
  const line = $("[data-yf-sum-line]", scope);
  if (!line) return;
  const n = stackCalc(stackData(c, scope), c);
  if (!n) return;
  const txt = sumLine(n);
  if (line.textContent !== txt) line.textContent = txt;
  const save = $("[data-yf-sum-save]", scope), sep = $("[data-yf-sum-sep]", scope);
  if (save) { const s = money(c, n.save); if (save.textContent !== s) save.textContent = s; }
  if (sep) sep.hidden = !txt;
  // Sprint 1C fix r2: the held code's part ("+ LOVE −$150") and the You save that includes it (CSS-gated).
  const saveL = $("[data-yf-sum-save-love]", scope);
  if (saveL) { const s = money(c, n.save + n.love); if (saveL.textContent !== s) saveL.textContent = s; }
  const wrap = $("[data-yf-sum]", scope);
  if (wrap) wrap.toggleAttribute("data-yf-love-ok", n.love > 0);
}
function initSumLine(el) {
  const c = ctl(el);
  if (!c) return;
  onBuy(c, () => paintSummary(el, c));
  onLoveCart(() => paintSummary(el, c));
  paintSummary(el, c);
}
function giftCheck() {
  // Evergreen gift (Sprint 1B): end 0 means no end date, nothing to re-check.
  const g = CFG.gift || {};
  const now = Date.now() / 1000;
  if (!g.end) return;
  if (now > g.end) $$("[data-yf-gift]").forEach((el) => { el.hidden = true; });
}

/* ---------------------------------------------------------------- sheets (M4) */
let openSheet = null, opener = null;
const HAS_DIALOG = typeof window.HTMLDialogElement === "function" && "showModal" in HTMLDialogElement.prototype;
function sheetOpen(dlg, from) {
  if (!HAS_DIALOG || !dlg || dlg.open) return false;
  if (openSheet) sheetClose(openSheet, true);
  opener = from || doc.activeElement;
  refreshSheet(dlg);
  try { dlg.showModal(); } catch (e) { return false; }
  openSheet = dlg;
  doc.documentElement.classList.add("yf-sheet-lock");
  const t = $(".yf-sheet__title", dlg);
  if (t) t.focus({ preventScroll: true });
  return true;
}
function sheetClose(dlg, instant) {
  if (!dlg || !dlg.open) return;
  const done = () => {
    dlg.classList.remove("is-closing");
    if (dlg.open) dlg.close();
    doc.documentElement.classList.remove("yf-sheet-lock");
    if (openSheet === dlg) openSheet = null;
    if (opener && opener.isConnected && !instant) opener.focus({ preventScroll: true });
  };
  if (instant || REDUCE) return done();
  dlg.classList.add("is-closing");
  setTimeout(done, 190);
}
function refreshSheet(dlg) {
  $$("[data-yf-plan-ctl]", dlg).forEach((el) => el.__yfPaint && el.__yfPaint());
  $$("[data-yf-box]", dlg).forEach(paintBox);
  const jump = $("[data-yf-sheet-jump]", dlg);
  if (jump) jump.hidden = !doc.getElementById((jump.getAttribute("href") || "#").slice(1));
}
function initSheets() {
  doc.addEventListener("click", (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const openEl = t.closest("[data-yf-sheet-open]");
    if (openEl) {
      const dlg = doc.getElementById(openEl.getAttribute("data-yf-sheet-open"));
      if (sheetOpen(dlg, openEl)) {
        e.preventDefault();
        const name = openEl.getAttribute("data-yf-sheet-name");
        if (name) track("yf_sheet_open", { sheet: name });
        else track("yf_offer_details", { gift_mode: (CFG.gift || {}).state || "" });
      }
      return;
    }
    const dlg = t.closest("dialog[data-yf-sheet]");
    if (!dlg) return;
    if (t.closest("[data-yf-sheet-close]")) { e.preventDefault(); sheetClose(dlg); return; }
    const jump = t.closest("[data-yf-sheet-jump]");
    if (jump) {
      const target = doc.getElementById((jump.getAttribute("href") || "#").slice(1));
      if (target) {
        e.preventDefault();
        sheetClose(dlg, true);
        target.scrollIntoView({ behavior: REDUCE ? "auto" : "smooth", block: "start" });
        const focusable = target.querySelector("input,button,a");
        if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), REDUCE ? 0 : 450);
      }
      return;
    }
    if (t.closest("[data-yf-sheet-cta]")) {
      const c = ctl(t);
      track("yf_sheet_cta", { sheet: (dlg.id.split("-").pop() || ""), state: c ? c.state : "" });
      if (c && (c.state === "added" || c.state === "unconfirmed")) sheetClose(dlg, true);
      return;
    }
    if (t === dlg) {
      const r = dlg.getBoundingClientRect();
      const x = e.clientX, y = e.clientY;
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) sheetClose(dlg);
    }
  });
  doc.addEventListener("cancel", (e) => {
    const dlg = e.target;
    if (dlg && dlg.matches && dlg.matches("dialog[data-yf-sheet]")) { e.preventDefault(); sheetClose(dlg); }
  }, true);
  doc.addEventListener("yf:buy", (e) => {
    const d = e.detail || {};
    if (d.state === "added" && openSheet) sheetClose(openSheet, true);
    if (openSheet) refreshSheet(openSheet);
  });
}

function initMaterials(el) {
  if (!HAS_DIALOG) return;
  const fallback = $("[data-yf-materials-fallback]", el);
  const content = $("[data-yf-materials-content]", el);
  const trigger = $("[data-yf-materials-open]", el);
  const body = $(".yf-sheet__body", el);
  if (!fallback || !content || !trigger || !body) return;
  body.appendChild(content);
  fallback.hidden = true;
  trigger.hidden = false;
}
function paintBox(list) {
  const c = ctl(list);
  const sleep = !!(c && c.target && c.target.key === "sleep");
  const sheet = list.closest(".yf-sheet__body") || list.parentNode;
  const lead = $("[data-yf-box-count]", sheet), not = $("[data-yf-box-not]", sheet);
  if (lead) lead.textContent = sleep ? lead.dataset.b : lead.dataset.a;
  if (not) not.textContent = sleep ? not.dataset.b : not.dataset.a;
  $$("[data-yf-box-sleep]", list).forEach((li) => { li.hidden = !sleep; });
  const sizes = json(list.getAttribute("data-sizes")) || {};
  const out = $("[data-yf-box-size]", list);
  const size = sizeOf(c);
  if (out) {
    if (size && sizes[size]) out.textContent = sizes[size];
    else out.innerHTML = Object.values(sizes).map((s) => s.replace(/[&<>]/g, "")).join("<br>");
  }
}
/* ---------------------------------------------------------------- bed plan */
const PLAN = { S: 2.6, C: 240, T: 40 };
function drawPlan(box, duvetName, mattress, pillows) {
  const svg = $("svg[data-yf-plan-svg]", box);
  if (!svg) return null;
  const duvets = json(box.getAttribute("data-duvets")) || {};
  const names = Object.keys(duvets);
  if (!names.length) return null;
  if (!duvets[duvetName]) duvetName = findDuvet(names, duvetFor(duvetName || "King"));
  const [dwcm, dlcm] = duvets[duvetName];
  const [mw, ml] = MATS[mattress] || MATS.King;
  const { S, C, T } = PLAN;
  const dW = (dwcm / 2.54) * S, dL = (dlcm / 2.54) * S, mW = mw * S, mL = ml * S;
  const dx = C - dW / 2, mx = C - mW / 2, dR = dx + dW, mR = mx + mW, dB = T + dL, mB = T + mL;
  const side = (dwcm - mw * 2.54) / 2 / 2.54, foot = (dlcm - ml * 2.54) / 2.54;
  const sy = T + mL * 0.42, ly = T + mL * 0.64;
  const q = (k) => svg.querySelector(`[data-p="${k}"]`);
  const set = (el, a) => { if (el) Object.keys(a).forEach((k) => el.setAttribute(k, typeof a[k] === "number" ? f1(a[k]) : a[k])); };
  const vis = (el, on) => { if (!el) return; if (on) el.removeAttribute("visibility"); else el.setAttribute("visibility", "hidden"); };
  set(q("hb"), { x: mx - 8, width: mW + 16 });
  set(q("dsh"), { x: dx, width: dW, height: dL });
  set(q("d"), { x: dx, width: dW, height: dL });
  set(q("din"), { x: dx + 7, width: dW - 14, height: dL - 14 });
  set(q("m"), { x: mx, width: mW, height: mL });
  const pw = (mW - 18) / 2, isSet = pillows === "set";
  [["p1", mx + 6], ["p2", mx + 12 + pw]].forEach(([k, x]) => {
    const el = q(k);
    set(el, { x, width: pw, fill: isSet ? "#FFFFFF" : "none", stroke: isSet ? "#24232B" : "#817C8A" });
    if (isSet) { el.removeAttribute("stroke-dasharray"); el.removeAttribute("stroke-linecap"); }
    else { el.setAttribute("stroke-dasharray", "1.5 4"); el.setAttribute("stroke-linecap", "round"); }
  });
  set(q("ml"), { y: ly }); q("ml").textContent = `${mattress} mattress`;
  set(q("md"), { y: ly + 23 }); q("md").textContent = `${mw} × ${ml} in`;
  q("sl").setAttribute("d", `M${f1(mR)} ${f1(sy)}H${f1(dR)}M${f1(mR)} ${f1(sy - 6)}v12M${f1(dR)} ${f1(sy - 6)}v12`);
  vis(q("sl"), side >= 0.4);
  set(q("st"), { x: dR + 10, y: sy + 6 }); q("st").textContent = `${r1(side)} in`; vis(q("st"), side >= 0.4);
  q("fl").setAttribute("d", `M${C} ${f1(mB)}V${f1(dB)}M${C - 6} ${f1(mB)}h12M${C - 6} ${f1(dB)}h12`);
  vis(q("fl"), foot >= 0.4);
  set(q("ft"), { y: dB + 26 }); q("ft").textContent = `${r1(foot)} in`; vis(q("ft"), foot >= 0.4);
  const dwi = Math.round(dwcm / 2.54), dli = Math.round(dlcm / 2.54);
  svg.setAttribute("aria-label", `Top view, to scale: ${duvetName} duvet, ${dwi} by ${dli} inches (${Math.round(dwcm)} by ${Math.round(dlcm)} cm), on a ${mattress} mattress, ${mw} by ${ml} inches. ${r1(side)} inches past each side and ${r1(foot)} inches past the foot, laid flat.`);
  const lg = (k, txt) => { const el = box.querySelector(`[data-p="${k}"]`); if (el) el.textContent = txt; };
  lg("lg-d", `${duvetName} duvet, ${dwi} × ${dli} in`);
  lg("lg-m", `${mattress} mattress, ${mw} × ${ml} in`);
  lg("lg-p", isSet ? "2 Cloud Pillows" : "Pillows shown for styling");
  const psw = box.querySelector('[data-p="lg-psw"]');
  if (psw) psw.classList.toggle("is-set", isSet);
  box.dataset.duvet = duvetName;
  box.dataset.mattress = mattress;
  return { duvet: duvetName, mattress, side: r1(side), foot: r1(foot), widthIn: dwi, names };
}
function initPlanCtl(root) {
  const c = ctl(root);
  const box = $("[data-yf-plan]", root);
  if (!box) return;
  const out = $("[data-yf-plan-out]", root);
  const numeral = $("[data-yf-plan-numeral]", root);
  const support = $("[data-yf-plan-support]", root);
  const source = root.getAttribute("data-yf-plan-source") || "";
  const mats = $$("input[data-yf-mattress]", root);
  const duvs = $$("input[data-yf-duvet]", root);
  let userMattress = null;
  function paint() {
    const names = Object.keys(json(box.getAttribute("data-duvets")) || {});
    const size = sizeOf(c);
    const bed = stateBed() || {};
    let mattress = userMattress || bed.mattress || null;
    let duvet = size || (duvs.find((d) => d.checked) || {}).value || "";
    if (!duvet) duvet = findDuvet(names, mattress ? duvetFor(mattress) : "King");
    if (!mattress) mattress = MATS[duvet] ? duvet : "King";
    const checkedMat = mats.find((m) => m.checked);
    if (!userMattress && !bed.mattress && checkedMat && !size) mattress = checkedMat.value;
    mats.forEach((m) => { m.checked = m.value === mattress; });
    duvs.forEach((d) => { d.checked = d.value === duvet; });
    const pillows = c && c.target && c.target.key === "sleep" ? "set" : "styling";
    const r = drawPlan(box, duvet, mattress, pillows);
    if (!r) return;
    if (out) out.textContent = `${r.duvet} duvet on a ${r.mattress} mattress: ${r.side} in past each side and ${r.foot} in past the foot, laid flat.`;
    if (numeral) numeral.textContent = `${r.widthIn} in`;
    $$("[data-yf-plan-photo]", root).forEach((ph) => ph.classList.toggle("is-on", ph.getAttribute("data-yf-plan-photo") === r.mattress));
    if (support && support.dataset.tpl) {
      const txt = support.dataset.tpl.split("[size]").join(r.duvet).split("[width]").join(String(r.widthIn)).split("[side]").join(r.side).split("[foot]").join(r.foot);
      if (support.textContent !== txt) support.textContent = txt;
    }
  }
  root.__yfPaint = paint;
  root.addEventListener("change", (e) => {
    const t = e.target;
    if (t.matches("input[data-yf-mattress]")) {
      userMattress = t.value;
      track("yf_finder_step", { step: source || "fit_chip", mattress: t.value });
    } else if (t.matches("input[data-yf-duvet]")) {
      if (c) c.pick("1", t.value);
      track("yf_finder_step", { step: source || "fit_chip", duvet: t.value });
    }
    paint();
  });
  if (c) onBuy(c, paint);
  doc.addEventListener("yf:bed", paint);
  paint();
}

/* ---------------------------------------------------------------- media helpers */
function reveal(img) {
  if (!img || img.__yfIn) return;
  img.__yfIn = true;
  const done = () => img.classList.add("is-in");
  if (img.complete && img.naturalWidth) return done();
  img.addEventListener("load", () => { (img.decode ? img.decode().catch(() => {}) : Promise.resolve()).then(done); }, { once: true });
  img.addEventListener("error", done, { once: true });
}
function hydrate(scope) {
  $$("img[data-yf-src]", scope).forEach((img) => {
    if (img.dataset.yfSizes) img.sizes = img.dataset.yfSizes;
    if (img.dataset.yfSrcset) img.srcset = img.dataset.yfSrcset;
    img.src = img.dataset.yfSrc;
    img.removeAttribute("data-yf-src");
    reveal(img);
  });
  $$("img.yf-fade", scope).forEach(reveal);
}
function makeVideo(holder) {
  let v = $("video", holder);
  if (v) return v;
  v = doc.createElement("video");
  v.muted = true; v.defaultMuted = true;
  v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("preload", "none");
  if (!holder.dataset.end) v.loop = true;
  v.setAttribute("aria-label", holder.dataset.label || "");
  const poster = $("img", holder);
  if (poster && poster.currentSrc) v.setAttribute("poster", poster.currentSrc);
  const s = doc.createElement("source");
  s.src = holder.dataset.src; s.type = holder.dataset.type || "video/mp4";
  v.appendChild(s);
  const start = parseFloat(holder.dataset.start || "0") || 0, end = parseFloat(holder.dataset.end || "0") || 0;
  v.addEventListener("loadedmetadata", () => { if (start) v.currentTime = start; });
  if (end > start) v.addEventListener("timeupdate", () => { if (v.currentTime >= end || v.currentTime < start - 0.05) v.currentTime = start; });
  v.addEventListener("ended", () => { v.currentTime = start; v.play().catch(() => {}); });
  v.addEventListener("error", () => holder.classList.add("is-failed"), true);
  const btn = $("[data-yf-media-toggle]", holder.parentNode);
  const mark = (paused) => {
    holder.classList.toggle("is-playing", !paused);
    if (btn) { btn.setAttribute("aria-pressed", paused ? "true" : "false"); btn.setAttribute("aria-label", paused ? "Play video" : "Pause video"); }
  };
  v.addEventListener("pause", () => mark(true));
  v.addEventListener("playing", () => {
    holder.classList.remove("is-still");
    mark(false);
    if (!holder.__yfTracked) { holder.__yfTracked = true; track("yf_loop_start", { asset: holder.dataset.asset || "" }); }
  });
  holder.insertBefore(v, holder.firstChild);
  return v;
}
function playHolder(holder) {
  if (!holder || !holder.dataset.src) return;
  if (REDUCE || SAVE_DATA) { holder.classList.add("is-still"); return; }
  // iOS Safari refuses a scripted play() on a video it has not laid out yet, so a new video waits two frames, and a
  // refused play is tried again a few times while the holder is still meant to be playing.
  const fresh = !$("video", holder);
  const v = makeVideo(holder);
  holder.__yfWant = true;
  const go = (left) => {
    if (!holder.__yfWant || holder.__yfUserPaused) return;
    const p = v.play();
    if (p && p.catch) p.catch(() => {
      if (left > 0 && holder.__yfWant && !holder.__yfUserPaused) setTimeout(() => go(left - 1), 300);
      else holder.classList.add("is-still");
    });
  };
  if (fresh) requestAnimationFrame(() => requestAnimationFrame(() => go(3)));
  else go(3);
}
function pauseHolder(holder) {
  if (holder) holder.__yfWant = false;
  const v = holder && $("video", holder);
  if (v && !v.paused) v.pause();
}
function initMediaToggles() {
  doc.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest("[data-yf-media-toggle]");
    if (!btn) return;
    const holder = $("[data-yf-media]", btn.parentNode);
    if (!holder) return;
    const v = makeVideo(holder);
    if (v.paused) { holder.__yfUserPaused = false; v.play().catch(() => holder.classList.add("is-failed")); }
    else { holder.__yfUserPaused = true; v.pause(); }
  });
}
function watch(el, cb, opts) {
  if (!("IntersectionObserver" in window)) { cb(1); return; }
  const io = new IntersectionObserver((entries) => entries.forEach((en) => cb(en.intersectionRatio, en)), opts || { threshold: [0, 0.1, 0.5] });
  io.observe(el);
  return io;
}

/* ---------------------------------------------------------------- showroom (M3) */
function selectedContents(c) {
  const resolved = c.resolvedTarget && c.resolvedTarget();
  const target = resolved && !resolved.missing ? c.target : null;
  let parts = null, count = null;
  if (target && Array.isArray(target.contents) && target.contents.length) {
    const rows = target.contents.map((part) => {
      const quantity = part && part.quantity != null ? Number(part.quantity) : 1;
      return part && typeof part.component === "string" && part.component.trim() && Number.isInteger(quantity) && quantity > 0
        ? { component: part.component.trim(), quantity, filled: part.filled, description: typeof part.description === "string" ? part.description.trim() : "" } : null;
    });
    if (rows.every(Boolean)) {
      parts = rows;
      count = rows.reduce((sum, part) => sum + part.quantity, 0);
    }
  }
  if (target && count == null && Number.isInteger(Number(target.pieces)) && Number(target.pieces) > 0) count = Number(target.pieces);
  const name = target ? String(target.name || resolved.name || "") : "";
  const caption = target ? name + (count == null ? "" : " · " + count + (count === 1 ? " piece" : " pieces")) : "";
  return { target, parts, count, name, caption };
}
function contentsOfferPrice(data, size) {
  if (!data || !data.eligible || !data.cover || !Object.prototype.hasOwnProperty.call(data.cover, size)) return null;
  const value = Number(data.cover[size]);
  return Number.isFinite(value) && value > 0 ? value : null;
}
function contentsOfferData(sec) {
  return json($("script[data-yf-contents-offer]", sec));
}
function makeContentsOffer(component, sec) {
  const data = contentsOfferData(sec);
  if (!data || !data.eligible || !/cover/i.test(component)) return null;
  const wrap = doc.createElement("span"), was = doc.createElement("s"), label = doc.createElement("span"), value = doc.createElement("span"), free = doc.createElement("strong");
  wrap.className = "yf-content-offer";
  wrap.setAttribute("data-yf-content-cover", "");
  was.className = "yf-content-offer__value";
  label.className = "visually-hidden";
  label.textContent = data.text.value + " ";
  value.setAttribute("data-yf-content-cover-value", "");
  was.append(label, value);
  free.className = "yf-content-offer__free";
  free.textContent = data.text.free;
  wrap.append(was, free);
  return wrap;
}
function paintContentsOffers(sec, c) {
  const data = contentsOfferData(sec);
  if (!data) return;
  const value = contentsOfferPrice(data, sizeOf(c) || data.size);
  $$("[data-yf-content-cover]", sec).forEach((row) => {
    const was = $(".yf-content-offer__value", row), amount = $("[data-yf-content-cover-value]", row);
    if (was) was.hidden = value == null;
    if (amount) amount.textContent = value == null ? "" : money(c, value);
  });
  $$("[data-yf-content-gift]", sec).forEach((gift) => {
    const giftEnd = CFG.gift && Number(CFG.gift.end);
    const expired = giftEnd > 0 && Date.now() / 1000 > giftEnd;
    gift.hidden = !data.gift.on || expired || sflag("yf:gift:nodisc");
  });
}
function initContents(sec) {
  const c = ctl(sec), list = $("[data-yf-contents-list]", sec);
  if (!c || !list) return;
  const countEl = $("[data-yf-contents-count]", sec), lede = $("[data-yf-contents-lede]", sec);
  const exclusions = $("[data-yf-contents-exclusions]", sec), exclusionsText = $("[data-yf-contents-exclusions-text]", sec);
  const base = { html: list.innerHTML, count: countEl && countEl.textContent, countHidden: countEl && countEl.hidden, lede: lede && lede.innerHTML, exclusions: exclusionsText && exclusionsText.textContent, exclusionsHidden: exclusions && exclusions.hidden };
  const emptyKeywords = (sec.getAttribute("data-yf-empty-keywords") || "").toLowerCase().split(",").map((word) => word.trim()).filter(Boolean);
  let signature = null;
  function paint() {
    const { target, parts, count, name, caption } = selectedContents(c);
    const excluded = target && typeof target.exclusions === "string" ? target.exclusions.trim() : "";
    const variantKey = chosen(c) ? String(c.variant.id) : "";
    const next = JSON.stringify([variantKey, target && target.key, name, count, parts, excluded]);
    if (signature === next) { paintContentsOffers(sec, c); return; }
    signature = next;
    if (!target) {
      list.innerHTML = base.html;
      if (countEl) { countEl.textContent = base.count; countEl.hidden = base.countHidden; }
      if (lede) lede.innerHTML = base.lede;
      if (exclusionsText) exclusionsText.textContent = base.exclusions;
      if (exclusions) exclusions.hidden = base.exclusionsHidden;
      paintContentsOffers(sec, c);
      return;
    }
    if (countEl) { countEl.textContent = count == null ? "" : count + " " + sec.getAttribute("data-yf-count-label"); countEl.hidden = count == null; }
    if (lede) lede.textContent = caption;
    list.replaceChildren(...(parts || [{ component: name, quantity: null }]).map((part) => {
      const row = doc.createElement("li"), qty = doc.createElement("span"), body = doc.createElement("div"), title = doc.createElement("p"), component = doc.createElement("span");
      row.className = "yfx-contents__row";
      qty.className = "yfx-contents__qty";
      qty.textContent = part.quantity == null ? "" : String(part.quantity);
      title.className = "yfx-contents__name";
      component.textContent = part.component;
      title.appendChild(component);
      const tagKind = part.filled === true ? "filled" : part.filled === false && emptyKeywords.some((word) => part.component.toLowerCase().includes(word)) ? "empty" : "";
      const tagText = tagKind && sec.getAttribute("data-yf-" + tagKind + "-label");
      if (tagText) {
        const tag = doc.createElement("span");
        tag.className = "yfx-contents__tag yfx-contents__tag--" + tagKind;
        tag.textContent = tagText;
        title.appendChild(tag);
      }
      body.appendChild(title);
      const offer = makeContentsOffer(part.component, sec);
      if (offer) body.appendChild(offer);
      if (part.description) {
        const desc = doc.createElement("p");
        desc.className = "yfx-contents__desc";
        desc.textContent = part.description;
        body.appendChild(desc);
      }
      row.appendChild(qty);
      row.appendChild(body);
      return row;
    }));
    if (exclusionsText) exclusionsText.textContent = excluded;
    if (exclusions) exclusions.hidden = !excluded;
    paintContentsOffers(sec, c);
  }
  onBuy(c, paint);
  onLoveCart(paint);
  paint();
}
function initPdpContents(sec) {
  const c = ctl(sec), rows = $("[data-yf-pdp-contents-rows]", sec), count = $("[data-yf-pdp-contents-count]", sec);
  if (!c || !rows || !count) return;
  const lede = $("[data-yf-pdp-contents-lede]", sec), exclusions = $("[data-yf-pdp-contents-exclusions]", sec), link = $("[data-yf-pdp-contents-link]", sec);
  const simple = sec.getAttribute("data-yf-simple-contents") === "true";
  const tags = $$(".yf-contents__tag", rows), filledTag = tags.find((tag) => tag.classList.contains("yf-contents__tag--filled")), emptyTag = tags.find((tag) => !tag.classList.contains("yf-contents__tag--filled"));
  const base = { rows: rows.innerHTML, count: count.innerHTML, lede: lede && lede.innerHTML, exclusions: exclusions && exclusions.textContent, exclusionsHidden: exclusions && exclusions.hidden, linkHidden: link && link.hidden };
  let signature = null;
  function paint() {
    const { target, parts, caption, name } = selectedContents(c);
    const excluded = target && typeof target.exclusions === "string" ? target.exclusions.trim() : "";
    const variantKey = chosen(c) ? String(c.variant.id) : "";
    const next = JSON.stringify([variantKey, target && target.key, caption, parts, excluded, target && target.note]);
    if (signature === next) { paintContentsOffers(sec, c); return; }
    signature = next;
    if (!target) {
      rows.innerHTML = base.rows;
      count.innerHTML = base.count;
      if (lede) lede.innerHTML = base.lede;
      if (exclusions) { exclusions.textContent = base.exclusions; exclusions.hidden = base.exclusionsHidden; }
      if (link) link.hidden = base.linkHidden;
      paintContentsOffers(sec, c);
      return;
    }
    count.textContent = caption;
    if (lede) lede.textContent = typeof target.note === "string" && target.note.trim() ? target.note.trim() : caption;
    rows.replaceChildren(...(parts || [{ component: name, quantity: null }]).map((part) => {
      const row = doc.createElement("tr"), qty = doc.createElement("td"), cell = doc.createElement("th"), label = doc.createElement("span");
      qty.className = "yf-contents__qty";
      qty.textContent = part.quantity == null ? "" : String(part.quantity);
      cell.setAttribute("scope", "row");
      label.className = "yf-contents__name";
      label.textContent = part.component;
      cell.appendChild(label);
      const offer = makeContentsOffer(part.component, sec);
      if (offer) cell.appendChild(offer);
      if (!simple) {
        if (part.description) {
          const description = doc.createElement("span");
          description.className = "yf-contents__desc";
          description.textContent = part.description;
          cell.appendChild(description);
        }
        const tag = part.filled === true ? filledTag : part.filled === false ? emptyTag : null;
        if (tag) cell.appendChild(tag.cloneNode(true));
      }
      row.appendChild(qty);
      row.appendChild(cell);
      return row;
    }));
    if (exclusions) { exclusions.textContent = excluded; exclusions.hidden = !excluded; }
    if (link) link.hidden = true;
    paintContentsOffers(sec, c);
  }
  onBuy(c, paint);
  onLoveCart(paint);
  paint();
}
function initContentsNote(el) {
  const c = ctl(el);
  if (!c) return;
  const original = el.innerHTML;
  let signature = "";
  function paint() {
    const { target, parts, caption, name } = selectedContents(c);
    const note = target && typeof target.note === "string" ? target.note.trim() : "";
    const text = target ? note || (parts ? name + ": " + parts.map((part) => part.quantity + " × " + part.component).join("; ") + "." : caption) : "";
    const next = target ? JSON.stringify([target.key, text]) : "";
    if (signature === next) return;
    signature = next;
    if (target) el.textContent = text;
    else el.innerHTML = original;
  }
  onBuy(c, paint);
  paint();
}
function initShowroomContents(sec, tabs, currentTab, cap) {
  const c = ctl(sec);
  if (!c) return;
  const entries = tabs.map((tab) => {
    const panel = doc.getElementById(tab.getAttribute("aria-controls"));
    if (!panel || panel.getAttribute("data-type") !== "contents") return null;
    const box = $("[data-yf-sr-box]", panel);
    const num = box && $(".yf-sr__boxnum", box), label = box && $(".yf-sr__boxlbl", box);
    const list = box && $("[data-yf-sr-parts]", box), tabcap = $(".yf-sr__tabcap", tab);
    if (!num || !label || !list) return null;
    return {
      tab, num, label, list, tabcap,
      filledIcon: $(".yf-icon--cloud", list), emptyIcon: $(".yf-icon--check", list),
      base: { num: num.textContent, label: label.textContent, html: list.innerHTML, className: list.className, caption: tab.getAttribute("data-caption") || "", tabcap: tabcap ? tabcap.textContent : "" },
      signature: ""
    };
  }).filter(Boolean);
  if (!entries.length) return;
  function paint() {
    const { target, parts, count, name, caption } = selectedContents(c);
    const signature = target ? JSON.stringify([target.key, name, count, parts]) : "";
    entries.forEach((entry) => {
      if (entry.signature === signature) return;
      entry.signature = signature;
      if (target) {
        entry.num.textContent = count == null ? "" : String(count);
        entry.label.textContent = count == null ? name : count + (count === 1 ? " piece in the box" : " pieces in the box");
        entry.list.replaceChildren(...(parts || [{ component: name, quantity: null, filled: false }]).map((part) => {
          const li = doc.createElement("li"), text = doc.createElement("span");
          const icon = (part.filled === true ? entry.filledIcon : entry.emptyIcon) || entry.emptyIcon || entry.filledIcon;
          if (icon) li.appendChild(icon.cloneNode(true));
          text.textContent = part.quantity == null ? part.component : part.quantity + " × " + part.component;
          li.appendChild(text);
          return li;
        }));
        entry.list.classList.add("yf-sr__boxlist--parts");
      } else {
        entry.num.textContent = entry.base.num;
        entry.label.textContent = entry.base.label;
        entry.list.innerHTML = entry.base.html;
        entry.list.className = entry.base.className;
      }
      const nextCaption = target ? caption : entry.base.caption;
      entry.tab.setAttribute("data-caption", nextCaption);
      if (entry.tabcap) entry.tabcap.textContent = target ? caption : entry.base.tabcap;
      if (cap && currentTab() === entry.tab) cap.textContent = nextCaption;
    });
  }
  onBuy(c, paint);
  paint();
}
function initShowroom(sec) {
  const tabs = $$('[role="tab"]', sec);
  const panels = $$('[role="tabpanel"]', sec);
  const cap = $("[data-yf-sr-caption]", sec);
  const stage = $("[data-yf-sr-stage]", sec);
  if (!tabs.length) return;
  let current = tabs.find((t) => t.getAttribute("aria-selected") === "true") || tabs[0];
  let inView = 0;
  initShowroomContents(sec, tabs, () => current, cap);
  const panelOf = (tab) => doc.getElementById(tab.getAttribute("aria-controls"));
  const framePanel = (panel) => {
    if (!stage) return;
    const ratio = panel?.getAttribute("data-type") === "image" ? Number(panel.getAttribute("data-image-ratio")) : 0.8;
    stage.style.setProperty("--yf-sr-ratio", Number.isFinite(ratio) && ratio > 0 ? ratio : 0.8);
  };
  function load(tab) { const p = panelOf(tab); if (p && !p.__yfLoaded) { p.__yfLoaded = true; hydrate(p); } }
  function select(tab, focus, user) {
    if (!tab || tab === current && !user) return;
    const prev = current;
    current = tab;
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
    });
    const pNew = panelOf(tab), pOld = prev && prev !== tab ? panelOf(prev) : null;
    load(tab);
    if (pOld) {
      pauseHolder($("[data-yf-media]", pOld));
      pOld.classList.remove("is-on");
      setTimeout(() => { if (current !== prev) pOld.hidden = true; }, REDUCE ? 0 : 190);
    }
    if (pNew) {
      pNew.hidden = false;
      framePanel(pNew);
      requestAnimationFrame(() => pNew.classList.add("is-on"));
      $$("[data-yf-plan-ctl]", pNew).forEach((el) => el.__yfPaint && el.__yfPaint());
      const holder = $("[data-yf-media]", pNew);
      if (holder && inView >= 0.5 && !holder.__yfUserPaused) playHolder(holder);
    }
    if (cap) cap.textContent = tab.getAttribute("data-caption") || "";
    const list = tab.parentNode;
    if (list && list.scrollWidth > list.clientWidth) {
      const l = tab.offsetLeft - list.offsetLeft, r = l + tab.offsetWidth;
      if (l < list.scrollLeft + 20 || r > list.scrollLeft + list.clientWidth - 24) list.scrollTo({ left: Math.max(0, l - 20), behavior: REDUCE ? "auto" : "smooth" });
    }
    if (focus) tab.focus({ preventScroll: true });
    if (user) track("yf_chip_open", { chip: tab.getAttribute("data-chip") || "", media_type: pNew ? pNew.getAttribute("data-type") || "" : "" });
  }
  sec.addEventListener("click", (e) => {
    const tab = e.target.closest('[role="tab"]');
    if (tab && sec.contains(tab)) { select(tab, false, true); return; }
    const back = e.target.closest("[data-yf-sr-back]");
    if (back) {
      const p = back.closest('[role="tabpanel"]');
      const holder = p && $("[data-yf-media]", p);
      if (holder) { pauseHolder(holder); holder.hidden = true; }
      if (p) { p.classList.remove("is-alt"); const a = $("[data-yf-sr-alt]", p); if (a) a.focus(); }
      return;
    }
    const alt = e.target.closest("[data-yf-sr-alt]");
    if (alt) {
      e.preventDefault();
      const p = alt.closest('[role="tabpanel"]');
      const holder = p && $("[data-yf-media]", p);
      if (holder) {
        p.classList.add("is-alt");
        holder.hidden = false;
        hydrate(holder);
        if (REDUCE || SAVE_DATA) { const v = makeVideo(holder); v.play().catch(() => {}); } else playHolder(holder);
        const bk = $("[data-yf-sr-back]", p); if (bk) bk.focus({ preventScroll: true });
        track("yf_chip_open", { chip: "in_the_box_video", media_type: "video" });
      }
    }
  });
  sec.addEventListener("keydown", (e) => {
    const tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    const i = tabs.indexOf(tab);
    let n = null;
    if (e.key === "ArrowRight" || e.key === "ArrowDown") n = tabs[(i + 1) % tabs.length];
    else if (e.key === "ArrowLeft" || e.key === "ArrowUp") n = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === "Home") n = tabs[0];
    else if (e.key === "End") n = tabs[tabs.length - 1];
    if (n) { e.preventDefault(); select(n, true, true); }
  });
  tabs.forEach((t) => {
    const pre = () => load(t);
    t.addEventListener("pointerenter", pre, { passive: true });
    t.addEventListener("focus", pre);
    t.addEventListener("touchstart", pre, { passive: true });
  });
  watch(stage || sec, (ratio) => {
    inView = ratio;
    const holder = $("[data-yf-media]", panelOf(current) || sec);
    if (!holder) return;
    if (ratio >= 0.5 && !holder.__yfUserPaused && !holder.hidden) playHolder(holder);
    else if (ratio < 0.1) pauseHolder(holder);
  }, { threshold: [0, 0.1, 0.5] });
  framePanel(panelOf(current));
  hydrate(panelOf(current));
  panelOf(current) && (panelOf(current).__yfLoaded = true);
  const start = Q.get("chip");
  if (start) { const t = tabs.find((x) => x.getAttribute("data-chip") === start); if (t) select(t, false, false); }
  // Sprint 1B (K1): the preselected chip starts in view on a phone rail (fit view: "Your bed size"). Only the rail
  // scrolls, never the page, and without smooth motion.
  const rail = current && current.parentNode;
  if (rail && rail.scrollWidth > rail.clientWidth + 1) {
    const l = current.offsetLeft - rail.offsetLeft, r = l + current.offsetWidth;
    if (l < rail.scrollLeft || r > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = Math.max(0, l - 20);
  }
}

/* ---------------------------------------------------------------- views (M2) */
function initView(sec) {
  const view = sec.getAttribute("data-yf-view");
  const c = ctl(sec);
  let landed = false;
  const land = () => { if (landed) return; landed = true; track("yf_view_landed", { view, has_variant: !!Q.get("variant") }); };
  if (Q.get("view") === view) land();
  else watch(sec, (r) => { if (r > 0) land(); }, { threshold: [0, 0.01] });
  sec.addEventListener("click", (e) => {
    const cta = e.target.closest("[data-yf-view-cta]");
    if (cta) track("yf_view_cta", { view, cta: cta.getAttribute("data-yf-view-cta") });
  });
  $$("img.yf-fade", sec).forEach(reveal);
  $$("[data-yf-media][data-autoplay]", sec).forEach((holder) => {
    watch(holder, (ratio) => {
      if (ratio >= 0.5 && !holder.__yfUserPaused) playHolder(holder);
      else if (ratio < 0.1) pauseHolder(holder);
    }, { threshold: [0, 0.1, 0.5] });
  });
  $$("[data-yf-cover-link]", sec).forEach((a) => {
    const map = json(a.getAttribute("data-map")) || {};
    const out = $("[data-yf-cover-link-price]", a);
    const paint = () => {
      const m = chosen(c) && map[String(c.variant.id)];
      if (out) out.textContent = m ? m.p : a.getAttribute("data-from");
      if (m && m.u) a.href = m.u;
    };
    if (c) onBuy(c, paint);
    paint();
  });
}

/* ---------------------------------------------------------------- gift module (M5) */
function initGift(sec) {
  const c = ctl(sec);
  const saveEl = $("[data-yf-gift-save]", sec);
  const map = json(saveEl && saveEl.getAttribute("data-map")) || {};
  const paint = () => {
    if (saveEl) {
      const m = chosen(c) && map[String(c.variant.id)];
      saveEl.textContent = m || saveEl.getAttribute("data-none") || "";
    }
    const on = !!(c && c.target && c.target.key === "sleep");
    const nudge = $("[data-yf-set-choose]", sec);
    if (nudge && c) {
      nudge.setAttribute("aria-pressed", on ? "true" : "false");
      nudge.textContent = on ? nudge.dataset.on : nudge.dataset.off;
    }
    $$("[data-yf-box-swap]", sec).forEach((el) => { el.textContent = on ? el.dataset.b : el.dataset.a; });
  };
  if (c) onBuy(c, paint);
  paint();
  sec.addEventListener("click", (e) => {
    const n = e.target.closest("[data-yf-set-choose]");
    if (n && c) {
      e.preventDefault();
      const on = !(c.target && c.target.key === "sleep");
      if (window.YfLanding && window.YfLanding.choose) window.YfLanding.choose(on ? "sleep" : null, "gift_nudge");
      else c.setTarget(on ? "sleep" : null);
      const tiles = $("[data-yf-tiles]", c.root);
      if (tiles) {
        const r = tiles.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) tiles.scrollIntoView({ behavior: REDUCE ? "auto" : "smooth", block: "center" });
      }
      paint();
      return;
    }
    const h = e.target.closest("[data-yf-hint]");
    if (h) {
      e.preventDefault();
      const set = c && c.target ? c.target.name : h.getAttribute("data-base") || "Cloud Duvet Set";
      const size = sizeOf(c);
      const text = `A hint: the YumeFeel ${set}${size ? ", in " + size : ""}.`;
      share({ title: "YumeFeel Cloud Duvet Set", text, url: bedLink(c, { medium: "gift_hint" }) }, h, "yf_hint_share", "Link copied. Send it to whoever needs the hint.");
    }
  });
}

/* ---------------------------------------------------------------- saved bed, share, finder (M6) */
function loadBed() { try { return LS ? JSON.parse(LS.getItem(BED_KEY) || "null") : null; } catch (e) { return null; } }
function saveBed(bed) { try { if (LS) { LS.setItem(BED_KEY, JSON.stringify(bed)); return true; } } catch (e) {} return false; }
function bedLink(c, opts) {
  opts = opts || {};
  const base = location.pathname.replace(/\/$/, "");
  const u = new URL(base, location.origin);
  const vid = opts.variantId || (chosen(c) ? c.variant.id : null);
  if (vid) u.searchParams.set("variant", vid);
  const bed = opts.bed || stateBed() || {};
  if (bed.mattress) u.searchParams.set("bed", bed.mattress);
  const pkg = opts.pkg || (c && c.target && c.target.key === "sleep" ? "sleep" : "duvet");
  u.searchParams.set("set", pkg);
  const view = Q.get("view");
  if (view) u.searchParams.set("view", view);
  u.searchParams.set("utm_source", "share");
  u.searchParams.set("utm_medium", opts.medium || "saved_bed");
  u.searchParams.set("utm_campaign", "find_your_bed");
  return u.toString();
}
function statusIn(el, msg) {
  const box = el.closest("[data-yf-bed-row]") || el.parentNode;
  const s = $("[data-yf-bed-status]", box) || $("[data-yf-bed-status]", box.parentNode || doc);
  if (s) { s.textContent = ""; setTimeout(() => { s.textContent = msg; }, 60); }
  return s;
}
function share(data, btn, event, copiedMsg) {
  const done = (method) => track(event, { method });
  if (navigator.share) {
    navigator.share(data).then(() => done("share")).catch((err) => { if (err && err.name === "AbortError") return; copy(); });
    return;
  }
  copy();
  function copy() {
    const ok = () => { statusIn(btn, copiedMsg || "Link copied."); done("copy"); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(data.url).then(ok, field);
    } else field();
  }
  function field() {
    const box = btn.closest("[data-yf-bed-row]") || btn.parentNode;
    let wrap = $("[data-yf-copy]", box);
    if (!wrap) {
      wrap = doc.createElement("label");
      wrap.className = "yf-copy";
      wrap.setAttribute("data-yf-copy", "");
      wrap.innerHTML = '<span>Copy this link:</span><input type="text" readonly>';
      box.appendChild(wrap);
    }
    const input = $("input", wrap);
    input.value = data.url;
    input.focus();
    input.select();
    done("field");
  }
}
function describe(bed, gift) {
  const set = bed.package === "sleep" ? "Cloud Sleep Set" : "Cloud Duvet Set";
  return { set, text: gift ? `Their bed: ${set} in ${bed.duvet}, for a ${bed.mattress} mattress.` : `${set} in ${bed.duvet}, for a ${bed.mattress} mattress` };
}
function applyBed(c, bed, source) {
  if (!c || !bed) return;
  if (bed.duvet) c.pick("1", bed.duvet);
  if (window.YfLanding && window.YfLanding.choose) window.YfLanding.choose(bed.package === "sleep" ? "sleep" : null, null);
  else c.setTarget(bed.package === "sleep" ? "sleep" : null);
  setBed({ mattress: bed.mattress, hang: bed.hang });
  track(source === "restore" ? "yf_bed_restore" : "yf_bed_use", { mattress: bed.mattress, duvet: bed.duvet, package: bed.package });
}
function initSaved(box) {
  const c = ctl(box);
  const bed = loadBed();
  if (!bed || !bed.duvet || Q.get("variant")) return;
  const d = describe(bed);
  $("[data-yf-saved-text]", box).textContent = `Welcome back. Your saved bed: ${d.set} in ${bed.duvet}, for a ${bed.mattress} mattress.`;
  box.hidden = false;
  box.addEventListener("click", (e) => {
    if (e.target.closest("[data-yf-saved-use]")) {
      applyBed(c, bed, "restore");
      box.hidden = true;
      announce(c, `Your bed is selected: ${d.set} in ${bed.duvet}.`);
    } else if (e.target.closest("[data-yf-saved-clear]")) {
      try { if (LS) LS.removeItem(BED_KEY); } catch (err) {}
      box.hidden = true;
      announce(c, "Saved bed cleared.");
    }
  });
}
function initFinal(sec) {
  const c = ctl(sec);
  const btns = $$("[data-yf-final-set]", sec);
  const paint = () => {
    const sleep = !!(c && c.target && c.target.key === "sleep");
    btns.forEach((b) => b.setAttribute("aria-pressed", (b.getAttribute("data-yf-final-set") === "sleep") === sleep ? "true" : "false"));
  };
  const ctrl = $("[data-yf-final-sets]", sec);
  if (ctrl) ctrl.hidden = !(c && c.targets && c.targets.sleep);
  if (c && btns.length) {
    onBuy(c, paint);
    paint();
  }
  if (c && $("[data-yf-sum-line]", sec)) {
    onBuy(c, () => paintSummary(sec, c));
    onLoveCart(() => paintSummary(sec, c));
    paintSummary(sec, c);
  }
  sec.addEventListener("click", (e) => {
    const b = e.target.closest("[data-yf-final-set]");
    if (b && c) {
      const key = b.getAttribute("data-yf-final-set") === "sleep" ? "sleep" : null;
      if (window.YfLanding && window.YfLanding.choose) window.YfLanding.choose(key, "final");
      else c.setTarget(key);
      paint();
      return;
    }
    const save = e.target.closest("[data-yf-final-save]");
    if (save) {
      const bed = currentBed(c);
      if (!bed) { statusIn(save, "Choose a size first, then save it."); return; }
      const ok = saveBed(bed);
      statusIn(save, ok ? "Saved on this device. The link keeps it too." : "Copy the link to keep it.");
      track("yf_bed_save", { method: ok ? "device" : "link", mattress: bed.mattress, duvet: bed.duvet, package: bed.package });
      if (!ok) share({ title: "Your YumeFeel bed", text: "", url: bedLink(c) }, save, "yf_bed_share");
      return;
    }
    const send = e.target.closest("[data-yf-final-send]");
    if (send) {
      const bed = currentBed(c) || {};
      const set = c && c.target ? c.target.name : "Cloud Duvet Set";
      const text = `Here's the bed I'm looking at: YumeFeel ${set}${bed.duvet ? ", " + bed.duvet : ""}${bed.mattress ? ", for a " + bed.mattress + " mattress" : ""}.`;
      share({ title: "YumeFeel", text, url: bedLink(c) }, send, "yf_bed_share");
    }
  });
}
function currentBed(c) {
  if (!chosen(c)) return null;
  const duvet = sizeOf(c);
  const known = stateBed() || {};
  return {
    mattress: known.mattress || (MATS[duvet] ? duvet : "King"),
    duvet, variantId: c.variant.id,
    package: c.target && c.target.key === "sleep" ? "sleep" : "duvet",
    view: Q.get("view") || "", savedAt: new Date().toISOString().slice(0, 10),
  };
}
function initPackages(sec) {
  const c = ctl(sec);
  if (!c || !c.targets || !c.targets.sleep) return;
  sec.classList.add("is-targeted");
  const paint = () => {
    const key = c.target && c.target.key === "sleep" ? "sleep" : "base";
    $$("[data-yf-pk-card]", sec).forEach((card) => {
      const pkg = card.getAttribute("data-yf-pk-pkg");
      if (!pkg) return;
      const on = pkg === key;
      card.classList.toggle("is-chosen", on);
      const buy = $("[data-yf-pk-buyrow]", card), pick = $("[data-yf-pk-choose]", card);
      if (buy) buy.hidden = !on;
      if (pick) pick.hidden = on;
    });
  };
  sec.addEventListener("click", (e) => {
    const b = e.target.closest("[data-yf-pk-choose]");
    if (!b) return;
    e.preventDefault();
    const key = b.getAttribute("data-yf-pk-choose") === "sleep" ? "sleep" : null;
    if (window.YfLanding && window.YfLanding.choose) window.YfLanding.choose(key, "packages");
    else c.setTarget(key);
    paint();
    const main = c.root.querySelector('[data-yf-role="main"]');
    if (main) { main.scrollIntoView({ behavior: REDUCE ? "auto" : "smooth", block: "center" }); main.focus({ preventScroll: true }); }
  });
  onBuy(c, paint);
  paint();
}
function initFinder(sec) {
  const c = ctl(sec);
  const D = json($("script[data-yf-finder-data]", sec)) || {};
  const gift = sec.hasAttribute("data-gift");
  const box = $("[data-yf-plan]", sec);
  const result = $("[data-yf-result]", sec);
  const empty = $("[data-yf-result-empty]", sec), full = $("[data-yf-result-full]", sec);
  const line = $("[data-yf-result-line]", sec), nums = $("[data-yf-result-nums]", sec);
  const useBtn = $("[data-yf-use]", sec), buyRow = $("[data-yf-result-buy]", sec);
  const names = Object.keys(D.duvets || {});
  let used = false;
  const val = (name) => { const i = $(`input[name="${sec.id}-${name}"]:checked`, sec); return i ? i.value : ""; };
  function bed() {
    const mattress = val("mattress");
    if (!mattress) return null;
    const hang = "";
    const duvet = findDuvet(names, duvetFor(mattress));
    const pkg = val("set") || "duvet";
    const dv = (D.duvets || {})[duvet] || {};
    const sl = pkg === "sleep" ? (D.sleep || {})[String(dv.id)] : null;
    return { mattress, hang, duvet, package: pkg, variantId: dv.id, price: sl ? sl.price : dv.price, sleepOk: !!(D.sleep || {})[String(dv.id)] };
  }
  function paintOffer(b) {
    const offer = $("[data-yf-result-offer]", sec);
    if (!offer || !b) return;
    const n = stackFor(stackData(c, sec), b.variantId, b.package === "sleep" ? "sleep" : null);
    const txt = n ? sumLine(n) : "";
    offer.hidden = !txt;
    const out = $("[data-yf-result-offer-text]", offer);
    if (!out || !txt) return;
    // Sprint 1C fix r2: with the held code, "+ LOVE −$150" and a You save that includes it (CSS-gated).
    // Sprint 1C fix r3: the same parts as the closing boxes: "−$150" never breaks after its "−" ([data-yf-sum-love] > span),
    // "You save $…" stays whole (.yf-nw), and on phones it takes its own line with no "·" (sections/yf-find-bed).
    const lvPart = n.love > 0 ? `<span class="yf-lv-on" data-yf-sum-love> +\u00a0${n.code}\u00a0<span>−${money(c, n.love)}</span></span>` : "";
    const lvSave = n.love > 0 ? `<span class="yf-lv-on">${money(c, n.save + n.love)}</span>` : "";
    const html = `<span data-yf-sum${n.love > 0 ? " data-yf-love-ok" : ""}>${txt}${lvPart}<span data-yf-sum-sep> · </span><span class="yf-nw">You save <strong><span class="yf-lv-off">${money(c, n.save)}</span>${lvSave}</strong></span></span>`;
    if (out.innerHTML !== html) out.innerHTML = html;
  }
  onLoveCart(() => paintOffer(bed()));
  function paint(stepName) {
    const b = bed();
    $$("[data-yf-set-price]", sec).forEach((el) => {
      const key = el.getAttribute("data-yf-set-price");
      if (!el.hasAttribute("data-yf-orig")) el.setAttribute("data-yf-orig", el.innerHTML);
      if (!b) { el.innerHTML = el.getAttribute("data-yf-orig"); return; }
      const dv = (D.duvets || {})[b.duvet] || {};
      const rec = key === "sleep" ? (D.sleep || {})[String(dv.id)] || {} : dv;
      if (rec.price == null) { el.textContent = ""; return; }
      if (window.YfBuy && window.YfBuy.paintPair) window.YfBuy.paintPair(el, rec.price, rec.compare || 0, c ? c.cfg.moneyFormat : undefined);
      else el.textContent = money(c, rec.price);
    });
    if (empty) empty.hidden = !!b;
    if (result) result.classList.toggle("is-empty", !b);
    if (!b) {
      // Nothing picked (or Start over): the labelled example, a King duvet on a King.
      if (box && result && !result.__yfExample) { drawPlan(box, findDuvet(names, "King"), "King", "styling"); result.__yfExample = true; }
      return;
    }
    if (result) result.__yfExample = false;
    const r = drawPlan(box, b.duvet, b.mattress, b.package === "sleep" ? "set" : "styling");
    const set = b.package === "sleep" ? D.sleepName || "Cloud Sleep Set" : D.baseName || "Cloud Duvet Set";
    line.textContent = `${b.mattress} mattress · ${set} in ${b.duvet}${b.price != null ? " · " + money(c, b.price) : ""}`;
    nums.textContent = r ? `${r.side} in past each side and ${r.foot} in past the foot, laid flat.` : "";
    paintOffer(b);
    if (full) {
      const match = (D.full || []).find((f) => f.a && f.o === b.mattress);
      full.hidden = !match;
      if (match) {
        const a = $("a", full);
        a.href = D.fullUrl + "?variant=" + match.id;
        const esc = (s) => String(s).replace(/[&<>"]/g, "");
        $("[data-yf-full-text]", full).innerHTML = `Want the sheets too? ${esc(D.fullName || "Full Cloud Bed Set")} in ${esc(match.o)}, ${match.c > match.p ? `<s class="yf-was">${money(c, match.c)}</s> ` : ""}${money(c, match.p)}`;
      }
    }
    setBed({ mattress: b.mattress, hang: b.hang });
    if (stepName) {
      track("yf_finder_step", { step: stepName, mattress: b.mattress, duvet: b.duvet, package: b.package });
      track("yf_finder_result", { mattress: b.mattress, duvet: b.duvet, package: b.package });
    }
    syncUse(b);
  }
  function syncUse(b) {
    if (!useBtn || !buyRow) return;
    // Sprint 1B fix r1: coerce like the other target checks; with no package target c.target is null and
    // (null === false) kept the finder's own Add hidden for the default "Duvet + cover" choice.
    const isSleep = !!(c.target && c.target.key === "sleep");
    const selected = used && chosen(c) && sizeOf(c) === b.duvet && isSleep === (b.package === "sleep");
    useBtn.hidden = !!selected;
    buyRow.hidden = !selected;
  }
  sec.addEventListener("change", (e) => {
    const n = e.target.name || "";
    if (!n.startsWith(sec.id + "-")) return;
    const step = n.slice(sec.id.length + 1);
    used = false;
    paint(step);
  });
  sec.addEventListener("click", (e) => {
    const ns = e.target.closest("[data-yf-notsure]");
    if (ns) {
      const t = $("[data-yf-notsure-text]", sec);
      if (t) { t.hidden = !t.hidden; ns.setAttribute("aria-expanded", t.hidden ? "false" : "true"); }
      return;
    }
    const b = bed();
    if (e.target.closest("[data-yf-use]")) {
      if (!b || !c) return;
      applyBed(c, b, "use");
      used = true;
      syncUse(b);
      announce(c, `Your bed is selected: ${b.package === "sleep" ? D.sleepName : D.baseName} in ${b.duvet}.`);
      const cta = $("[data-yf-result-buy] [data-yf-buy-button]", sec);
      if (cta) cta.focus({ preventScroll: true });
      return;
    }
    const save = e.target.closest("[data-yf-save]");
    if (save) {
      if (!b) { statusIn(save, "Pick your mattress first."); return; }
      const rec = Object.assign({}, b, { view: Q.get("view") || "", savedAt: new Date().toISOString().slice(0, 10) });
      delete rec.price; delete rec.sleepOk;
      const ok = saveBed(rec);
      statusIn(save, ok ? "Saved on this device. The link keeps it too." : "Copy the link to keep it.");
      track("yf_bed_save", { method: ok ? "device" : "link", mattress: b.mattress, duvet: b.duvet, package: b.package });
      if (!ok) share({ title: "Your YumeFeel bed", text: "", url: bedLink(c, { variantId: b.variantId, bed: b, pkg: b.package }) }, save, "yf_bed_share");
      return;
    }
    const send = e.target.closest("[data-yf-send]");
    if (send) {
      if (!b) { statusIn(send, "Pick your mattress first."); return; }
      const set = b.package === "sleep" ? D.sleepName || "Cloud Sleep Set" : D.baseName || "Cloud Duvet Set";
      const text = gift ? `A hint: the YumeFeel ${set} in ${b.duvet}.` : `Here's the bed I'm looking at: YumeFeel ${set}, ${b.duvet}, for a ${b.mattress} mattress.`;
      share({ title: "YumeFeel", text, url: bedLink(c, { variantId: b.variantId, bed: b, pkg: b.package, medium: gift ? "gift_hint" : "saved_bed" }) }, send, "yf_bed_share");
    }
  });
  if (c) onBuy(c, () => { const b = bed(); if (b) syncUse(b); });
  const saved = loadBed();
  const restore = (Q.get("bed") && MATS[Q.get("bed")]) ? { mattress: Q.get("bed") } : null;
  const pre = restore || null;
  if (pre && pre.mattress) {
    const i = $(`input[name="${sec.id}-mattress"][value="${pre.mattress}"]`, sec);
    if (i) i.checked = true;
    const s = Q.get("set") === "sleep" ? $(`input[name="${sec.id}-set"][value="sleep"]`, sec) : null;
    if (s) s.checked = true;
  }
  const back = $("[data-yf-finder-back]", sec);
  if (back && saved && saved.duvet && !Q.get("variant")) {
    const d = describe(saved);
    $("[data-yf-finder-back-text]", back).textContent = `Welcome back. Your saved bed: ${d.set} in ${saved.duvet}, for a ${saved.mattress} mattress.`;
    back.hidden = false;
    back.addEventListener("click", (e) => {
      if (e.target.closest("[data-yf-saved-use]")) {
        [["mattress", saved.mattress], ["hang", saved.hang], ["set", saved.package]].forEach(([k, v]) => {
          const i = v && $(`input[name="${sec.id}-${k}"][value="${v}"]`, sec);
          if (i) i.checked = true;
        });
        paint();
        applyBed(c, saved, "restore");
        used = true;
        const b = bed(); if (b) syncUse(b);
        back.hidden = true;
      } else if (e.target.closest("[data-yf-saved-clear]")) {
        try { if (LS) LS.removeItem(BED_KEY); } catch (err) {}
        back.hidden = true;
      }
    });
  }
  initCapture(sec, bed);
  paint();
}
function initCapture(sec, bed) {
  const form = $("form[data-yf-capture]", sec);
  if (!form || !window.fetch || !window.crypto || !window.crypto.randomUUID) return;
  const err = $("[data-yf-capture-error]", form), ok = $("[data-yf-capture-ok]", sec);
  const email = $('input[type="email"]', form);
  const button = $('button[type="submit"]', form);
  const words = json($("[data-yf-capture-copy]", form)) || {};
  const data = json($("script[data-yf-finder-data]", sec)) || {};
  const siteId = form.dataset.siteId, listId = form.dataset.listId;
  if (!siteId || !listId) return;
  form.hidden = false;
  let busy = false, requestKey = "", requestId = "";
  const fail = (message) => { err.textContent = message; err.hidden = false; };
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (busy) return;
    if (ok) ok.hidden = true;
    const b = bed();
    if (!b) { fail(words.choose); return; }
    const properties = savedBedProperties(b, data, location.origin);
    if (!properties) { fail(words.unavailable); return; }
    const address = email.value.trim();
    if (!address || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) {
      fail(words.invalid);
      email.setAttribute("aria-invalid", "true");
      email.focus();
      return;
    }
    const saved = saveBed(Object.assign({}, b, { savedAt: new Date().toISOString().slice(0, 10) }));
    const key = JSON.stringify([address.toLowerCase(), properties]);
    if (key !== requestKey) { requestKey = key; requestId = crypto.randomUUID(); }
    busy = true;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = words.pending;
    form.setAttribute("aria-busy", "true");
    err.hidden = true;
    if (ok) ok.hidden = true;
    email.removeAttribute("aria-invalid");
    const post = async (resource, payload) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/${resource}?company_id=${encodeURIComponent(siteId)}`, {
          method: "POST", credentials: "omit", signal: controller.signal,
          headers: { "Content-Type": "application/vnd.api+json", revision: "2026-07-15" },
          body: JSON.stringify(payload)
        });
        if (response.status !== 202) throw new Error("Request not accepted");
      } finally { clearTimeout(timer); }
    };
    try {
      await post("subscriptions", { data: { type: "subscription", attributes: {
        custom_source: "YumeFeel saved bed", profile: { data: { type: "profile", attributes: {
          email: address, properties, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
        } } }
      }, relationships: { list: { data: { type: "list", id: listId } } } } });
      await post("events", { data: { type: "event", attributes: {
        properties, unique_id: requestId,
        metric: { data: { type: "metric", attributes: { name: "YF Saved Bed" } } },
        profile: { data: { type: "profile", attributes: { email: address } } }
      } } });
      if (ok) { ok.hidden = false; ok.textContent = words.success; }
      track("yf_capture_submit", { source: "find_your_bed", result: "accepted" });
      requestKey = "";
      requestId = "";
    } catch (error) {
      fail(saved ? words.errorSaved : words.errorUnsaved);
      track("yf_capture_submit", { source: "find_your_bed", result: "error" });
    } finally {
      busy = false;
      button.disabled = false;
      button.textContent = label;
      form.removeAttribute("aria-busy");
    }
  });
}
function savedBedProperties(bed, data, origin) {
  if (!bed || !["Queen", "King", "Cal King"].includes(bed.duvet)) return null;
  if (!["duvet", "sleep"].includes(bed.package)) return null;
  const base = (data.duvets || {})[bed.duvet];
  const sleep = bed.package === "sleep";
  if (!base || (!sleep && !base.available)) return null;
  if (String(base.id) !== String(bed.variantId)) return null;
  const variant = sleep ? (data.sleep || {})[String(base.id)] : base;
  const productId = sleep ? data.sleepProductId : data.baseProductId;
  const productPath = sleep ? data.sleepUrl : data.baseUrl;
  if (!variant || !/^\d+$/.test(String(variant.id)) || !/^\d+$/.test(String(productId)) || !productPath) return null;
  let url;
  try {
    url = new URL(productPath, origin);
    if (url.origin !== origin || !url.pathname.startsWith("/products/")) return null;
    url.search = "";
    url.hash = "";
    url.searchParams.set("variant", String(variant.id));
  } catch (error) { return null; }
  return {
    yf_signup_source: "F-02", yf_saved_product_id: String(productId),
    yf_saved_variant_id: String(variant.id), yf_saved_size: bed.duvet,
    yf_saved_package: sleep ? "sleep" : "duvet", yf_saved_url: url.toString()
  };
}

/* ---------------------------------------------------------------- boot */
const INIT = [
  ["[data-yf-materials]", initMaterials],
  ["[data-yf-tiles]", initTiles],
  ["[data-yf-offer]", initOffer],
  ["[data-yf-fitline]", initFitLine],
  ["[data-yfx-final-offer]", initSumLine],
  ["[data-yf-plan-ctl]", initPlanCtl],
  ["[data-yf-showroom]", initShowroom],
  ["[data-yf-contents]", initContents],
  ["[data-yf-pdp-contents]", initPdpContents],
  ["[data-yf-contents-note]", initContentsNote],
  ["[data-yf-view]", initView],
  ["[data-yf-gift-mod]", initGift],
  ["[data-yf-saved]", initSaved],
  ["[data-yf-final]", initFinal],
  ["[data-yf-packages]", initPackages],
  ["[data-yf-finder]", initFinder],
];
function boot(root) {
  INIT.forEach(([sel, fn]) => {
    $$(sel, root || doc).forEach((el) => {
      el.__yfInit = el.__yfInit || {};
      if (el.__yfInit[sel]) return;
      el.__yfInit[sel] = true;
      try { fn(el); } catch (e) { if (window.console) console.error("[yf-landing]", sel, e); }
    });
  });
  $$("[data-yf-box]", root || doc).forEach(paintBox);
  $$("[data-yf-needs]", root || doc).forEach((el) => { if (!doc.getElementById(el.getAttribute("data-yf-needs"))) el.hidden = true; });
}
if (!window.__yfLanding) {
  window.__yfLanding = true;
  initSheets();
  initMediaToggles();
  giftCheck();
  boot();
  doc.addEventListener("shopify:section:load", (e) => boot(e.target));
}

const openProductReference = (hash) => {
  if (!hash || hash.length < 2) return;
  let target;
  try { target = doc.getElementById(decodeURIComponent(hash.slice(1))); } catch (error) { return; }
  if (!target) return;
  const ancestor = target.closest("details[data-yf-reference]");
  if (ancestor) ancestor.open = true;
  target.querySelectorAll("details[data-yf-reference]").forEach((details) => { details.open = true; });
};
doc.addEventListener("click", (event) => {
  const link = event.target.closest("a[href]");
  if (!link) return;
  const url = new URL(link.href, location.href);
  if (url.origin === location.origin && url.pathname === location.pathname) openProductReference(url.hash);
});
window.addEventListener("hashchange", () => openProductReference(location.hash));
openProductReference(location.hash);
